(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/marketplace-data/browse-games/assets/javascripts/browse-games-actions.js') >= 0) return;  svs.modules.push('/components/marketplace-data/browse-games/assets/javascripts/browse-games-actions.js');
"use strict";


const _svs$components$marke = svs.components.marketplaceData.browseGames.helpers.constants,
  FILTER_UPDATE = _svs$components$marke.FILTER_UPDATE,
  LOAD_QUERYSTRING = _svs$components$marke.LOAD_QUERYSTRING;
const getFiltersFromQuery = svs.components.marketplaceData.browseGames.helpers.queryString.getFiltersFromQuery;
const updateFilterAction = (updatedFilter, groupId) => ({
  type: FILTER_UPDATE,
  updatedFilter,
  groupId
});
const loadFromQueryString = () => ({
  type: LOAD_QUERYSTRING,
  data: getFiltersFromQuery()
});
setGlobal('svs.components.marketplaceData.browseGames.actions', {
  FILTER_UPDATE,
  updateFilterAction,
  LOAD_QUERYSTRING,
  loadFromQueryString
});

 })(window);